import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";
import { subActivityList, subActivityUniqueList, subActivity_csv_export} from "constants/subActivity";

export const getSubActivityList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.subActivity_list(pageNum, filters);
    dispatch({ type: subActivityList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: subActivityList,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};

export const getSubActivityUniqueList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.subActivity_unique_list(pageNum, filters);
    dispatch({ type: subActivityUniqueList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: subActivityUniqueList,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};

export const addSubActivity = async (bodyData) => {
  try {
    const res = await api.add_subActivity(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const editSubActivity = async (id, bodyData) => {
  try {
    const res = await api.edit_subActivity(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const getSubActivityDetailsById = async (id) => {
  try {
    const res = await api.get_subActivity_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const deleteSubActivity = async (id) => {
  try {
    const res = await api.delete_subActivity_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const importSubActivity = async (fileData) => {
  try {
    const res = await api.import_subactivity(fileData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const exportSubActivityData = async (filtersJSON) => {
  try {
    const res = await api.subActivity_csv_export(filtersJSON) // correct call
    return res;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};
